import { defineStore } from 'pinia';
import { StoreModuleName } from '../../constants';

export const useEnvironmentStore = defineStore(StoreModuleName.ENVIRONMENT, () => {
  // if unset isMobile, default value is undefined. it will reset at client.
  const isMobile = ref<boolean | undefined>();
  const platform = ref<string>('');

  const setIsMobile = (val: boolean) => {
    isMobile.value = val;
  };

  const setPlatform = (val: string) => {
    platform.value = val;
  };

  return {
    isMobile,
    platform,
    setIsMobile,
    setPlatform,
  };
});
